import { render, staticRenderFns } from "./ClientFilter.vue?vue&type=template&id=1bd9ac58&"
import script from "./ClientFilter.vue?vue&type=script&lang=ts&"
export * from "./ClientFilter.vue?vue&type=script&lang=ts&"
import style0 from "./ClientFilter.vue?vue&type=style&index=0&id=1bd9ac58&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports